import { api } from '../instance';
export const getDefaultPage = (userId) => {
    return api.get(`/page/default/${userId}`);
};
//# sourceMappingURL=get-default-page.api.js.map